import {
  OPEN_HAMBURGER,
  SET_IS_ADMIN,
  CLOSE_HAMBURGER,
  SIGN_IN,
  SIGN_OUT,
  SET_DOCID,
  SET_PRODUCT,
  RESET,
  ADD_PENDING_DELETION,
  REMOVE_PENDING_DELETION,
  TOGGLE_LIFE_WEEK,
} from './types'

export const setIsAdmin = (isAdmin: boolean) => ({
  type: SET_IS_ADMIN,
  payload: isAdmin,
})

export const signIn = (uid: string) => ({
  type: SIGN_IN,
  payload: uid,
})

export const signOut = () => ({
  type: SIGN_OUT,
})
export const reset = () => ({
  type: RESET,
})
export const openHamburger = () => ({
  type: OPEN_HAMBURGER,
})
export const closeHamburger = () => ({
  type: CLOSE_HAMBURGER,
})
export const setDocId = (docId: null | string) => ({
  type: SET_DOCID,
  docId,
})
export const setProduct = (product: null | string) => ({
  type: SET_PRODUCT,
  product,
})
export const addPendingDeletion = (docId: string) => ({
  type: ADD_PENDING_DELETION,
  docId,
})
export const removePendingDeletion = (docId: string) => ({
  type: REMOVE_PENDING_DELETION,
  docId,
})
export const toggleLifeWeek = (chartId: 'discarded' | 'netPrice') => ({
  type: TOGGLE_LIFE_WEEK,
  chartId,
})
